import { PersonelServisRaporuPage } from './../pages/Raporlars/personel-servis-raporu/personel-servis-raporu';
import { BorcluCariHesaplarReportPage } from './../pages/Raporlars/borclu-cari-hesaplar-report/borclu-cari-hesaplar-report';
import { AlacakliCariHesaplarReportPage } from './../pages/Raporlars/alacakli-cari-hesaplar-report/alacakli-cari-hesaplar-report';
import { GeriBildirimEkleGuncellePage } from './../pages/Yonetim/geri-bildirim-ekle-guncelle/geri-bildirim-ekle-guncelle';
import { GeriBildirimPage } from './../pages/Yonetim/geri-bildirim/geri-bildirim';
import { ProgramKarsilamaPage } from './../pages/Yonetim/program-karsilama/program-karsilama';
import { MarkaeklemodalPage } from './../pages/Yonetim/MarkaIslemleri/markaeklemodal/markaeklemodal';
import { AksesuareklemodalPage } from './../pages/Yonetim/aksesuareklemodal/aksesuareklemodal';
import { ServerConfigPage } from './../pages/Yonetim/server-config/server-config';
import { KasaHareketleriRaporPage } from './../pages/Raporlars/kasa-hareketleri-rapor/kasa-hareketleri-rapor';
import { HakkindaPage } from './../pages/hakkinda/hakkinda';
import { KasiyerBazliRaporPage } from './../pages/Raporlars/kasiyer-bazli-rapor/kasiyer-bazli-rapor';
import { CarismsgonderPage } from './../pages/CariIslemleri/carismsgonder/carismsgonder';
import { GrupListesiPage } from './../pages/Yonetim/CariGrupIslemleri/grup-listesi/grup-listesi';
import { GrupEkleGuncellePage } from './../pages/Yonetim/CariGrupIslemleri/grup-ekle-guncelle/grup-ekle-guncelle';
import { ServisDetayPage } from './../pages/ServisKayit/servis-detay/servis-detay';
import { BekleyenListesiPage } from './../pages/ServisKayit/bekleyen-listesi/bekleyen-listesi';
import { PersonelEkleGuncellePage } from './../pages/CariIslemleri/personel-ekle-guncelle/personel-ekle-guncelle';
import { PersonelListesiPage } from './../pages/CariIslemleri/personel-listesi/personel-listesi';
import { TeslimEdilenListesiPage } from './../pages/ServisKayit/teslim-edilen-listesi/teslim-edilen-listesi';
import { SmsGonderPage } from './../pages/ServisKayit/sms-gonder/sms-gonder';
import { ServisDuzenlePage } from './../pages/ServisKayit/servis-duzenle/servis-duzenle';
import { ServisOdemeYapPage } from './../pages/ServisKayit/servis-odeme-yap/servis-odeme-yap';
import { ServisKayitArsivPage } from './../pages/ServisKayit/servis-kayit-arsiv/servis-kayit-arsiv';
import { RaporAnaSayfaPage } from './../pages/Raporlars/rapor-ana-sayfa/rapor-ana-sayfa';
import { ServishareketduzenlePage } from './../pages/ServisKayit/servishareketduzenle/servishareketduzenle';
import { HareketDetayPage } from './../pages/ServisKayit/hareket-detay/hareket-detay';
import { ServisHareketPage } from './../pages/ServisKayit/servis-hareket/servis-hareket';
import { MarkaListesiPage } from './../pages/Yonetim/MarkaIslemleri/marka-listesi/marka-listesi';
import { MarkaEklePage } from './../pages/Yonetim/MarkaIslemleri/marka-ekle/marka-ekle';
import { BirimListePage } from './../pages/Yonetim/BirimIslemleri/birim-liste/birim-liste';
import { BirimeklePage } from './../pages/Yonetim/BirimIslemleri/birimekle/birimekle';
import { AciklamaListePage } from './../pages/Yonetim/aciklama-liste/aciklama-liste';
import { AciklamaeklePage } from './../pages/Yonetim/aciklamaekle/aciklamaekle';
import { Camera } from '@ionic-native/camera';
import { KayitFormPage } from './../pages/ServisKayit/kayit-form/kayit-form';
import { IsListesiPage } from './../pages/ServisKayit/is-listesi/is-listesi';
import { BankaHavaleEftPage } from './../pages/Yonetim/BankaIslemleri/banka-havale-eft/banka-havale-eft';
import { BankListePage } from './../pages/Yonetim/BankaIslemleri/bank-liste/bank-liste';
import { BankaHareketPage } from './../pages/Yonetim/BankaIslemleri/banka-hareket/banka-hareket';
import { BankaEkleGuncellePage } from './../pages/Yonetim/BankaIslemleri/banka-ekle-guncelle/banka-ekle-guncelle';
import { GelirgidereklePage } from './../pages/Yonetim/gelirgider/gelirgiderekle/gelirgiderekle';
import { HareketdetayPage } from './../pages/CariIslemleri/hareketdetay/hareketdetay';
import { CariHareketleriPage } from './../pages/CariIslemleri/cari-hareketleri/cari-hareketleri';
import { CarialacakdekontPage } from './../pages/CariIslemleri/carialacakdekont/carialacakdekont';
import { KasaeklePage } from './../pages/Yonetim/KasaIslemleri/kasaekle/kasaekle';
import { KasalistePage } from './../pages/Yonetim/KasaIslemleri/kasaliste/kasaliste';
import { KullaniciListePage } from './../pages/Yonetim/kullanici-liste/kullanici-liste';
import { KullanicieklePage } from './../pages/Yonetim/kullaniciekle/kullaniciekle';
import { IsdurumPage } from './../pages/Yonetim/isdurum/isdurum';
import { YonetimAnaSayfaPage } from './../pages/Yonetim/yonetim-ana-sayfa/yonetim-ana-sayfa';
import { EtiketlistesiPage } from './../pages/StokIslemleri/etiketlistesi/etiketlistesi';
import { EtiketbasPage } from './../pages/StokIslemleri/etiketbas/etiketbas';
import { ReportsPage } from './../pages/Raporlars/reports/reports';
import { SatispagePage } from './../pages/Muhasebe/Satis/satispage/satispage';
import { DalProvider } from './../providers/dal/dal';
import { BarcodeScannerProvider } from './../providers/barcode-scanner-provider';
import { OzetPage } from './../pages/faturaislemleri/ozet/ozet';
import { UrunsecPage } from './../pages/faturaislemleri/urunsec/urunsec';
import { CarisecPage } from './../pages/faturaislemleri/carisec/carisec';
import { CariIslemPage } from './../pages/CariIslemleri/cari-islem/cari-islem';
import { GirisPage } from './../pages/giris/giris';
import { SayimGirisiPage } from './../pages/StokIslemleri/sayim-girisi/sayim-girisi';
import { CariOdemePage } from './../pages/cari-odeme/cari-odeme';
import { StokeklePage } from './../pages/StokIslemleri/stokekle/stokekle';
import { HttpModule } from '@angular/http';
import { Ortak } from './../providers/ortak';
import { Servis } from './../providers/servis';
import { BllOrtak } from './../providers/bll/bll-ortak';
import { CarilerPage } from './../pages/CariIslemleri/cariler/cariler';
import { CarieklePage } from './../pages/CariIslemleri/cariekle/cariekle';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StoklarPage } from '../pages/StokIslemleri/stoklar/stoklar';
import { CariTahsilatPage } from '../pages/CariIslemleri/cari-tahsilat/cari-tahsilat';
import { AndroidFullScreen } from '@ionic-native/android-full-screen';
import { CalendarModule } from "ion2-calendar";
import { Flashlight } from '@ionic-native/flashlight';
import { YapilanIslerPage } from '../pages/Yonetim/yapilan-isler/yapilan-isler';
import { PersonelPage } from '../pages/Yonetim/personel/personel';
import { IsdurumkayitPage } from '../pages/Yonetim/isdurumkayit/isdurumkayit';
import { CariborcdekontPage } from '../pages/CariIslemleri/cariborcdekont/cariborcdekont';
import { GelirgiderPage } from '../pages/Yonetim/gelirgider/gelirgider';
import { KategoriEklePage } from '../pages/Yonetim/KategoriIslemleri/kategori-ekle/kategori-ekle';
import { KategoriListePage } from '../pages/Yonetim/KategoriIslemleri/kategori-liste/kategori-liste';
import { SelectSearchableModule } from 'ionic-select-searchable';
import { Printer } from '@ionic-native/printer';
import { MarkaSecPage } from '../pages/marka-sec/marka-sec';
import { ProgramAyarlariPage } from '../pages/program-ayarlari/program-ayarlari';


@NgModule({
  declarations: [
    MyApp,
    HomePage,
    CarieklePage,
    CarilerPage,
    StoklarPage,
    StokeklePage,
    CariTahsilatPage,
    CariOdemePage,
    SayimGirisiPage,
    GirisPage,
    GelirgiderPage,
    CariIslemPage,
    CarisecPage,
    UrunsecPage,
    OzetPage,
    SatispagePage,
    ReportsPage,
    EtiketbasPage,
    EtiketlistesiPage,
    YonetimAnaSayfaPage,
    YapilanIslerPage,
    PersonelPage,
    IsdurumPage,
    IsListesiPage,
    IsdurumkayitPage,
    KullanicieklePage,
    KullaniciListePage,
    KasalistePage,
    KasaeklePage,
    CariborcdekontPage,
    CarialacakdekontPage,
    CariHareketleriPage,
    HareketdetayPage,
    GelirgidereklePage,
    BankaEkleGuncellePage,
    BankaHareketPage,
    BankListePage,
    BankaHavaleEftPage,
    KayitFormPage,
    AciklamaeklePage,
    AciklamaListePage,
    BirimeklePage,
    BirimListePage,
    KategoriEklePage,
    KategoriListePage,
    MarkaEklePage,
    MarkaListesiPage,
    ServisHareketPage,
    HareketDetayPage,
    ServishareketduzenlePage,
    RaporAnaSayfaPage,
    ServisKayitArsivPage,
    ServisOdemeYapPage,
    ServisDuzenlePage,
    SmsGonderPage,
    TeslimEdilenListesiPage,
    PersonelListesiPage,
    PersonelEkleGuncellePage,
    BekleyenListesiPage,
    ServisDetayPage,
    GrupEkleGuncellePage,
    GrupListesiPage,
    CarismsgonderPage,
    KasiyerBazliRaporPage,
    HakkindaPage,
    KasaHareketleriRaporPage,
    ServerConfigPage,
    AksesuareklemodalPage,
    MarkaeklemodalPage,
    ProgramKarsilamaPage,
    GeriBildirimPage,
    GeriBildirimEkleGuncellePage,
    AlacakliCariHesaplarReportPage,
    BorcluCariHesaplarReportPage,
    PersonelServisRaporuPage,
  MarkaSecPage,
  ProgramAyarlariPage,

  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp),
    CalendarModule,
    SelectSearchableModule,

  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    CarieklePage,
    CarilerPage,
    StoklarPage,
    StokeklePage,
    CariTahsilatPage,
    CariOdemePage,
    SayimGirisiPage,
    GirisPage,
    GelirgiderPage,
    CariIslemPage,
    CarisecPage,
    UrunsecPage,
    OzetPage,
    SatispagePage,
    ReportsPage,
    EtiketbasPage,
    EtiketlistesiPage,
    YonetimAnaSayfaPage,
    YapilanIslerPage,
    PersonelPage,
    IsdurumPage,
    IsListesiPage,
    IsdurumkayitPage,
    KullanicieklePage,
    KullaniciListePage,
    KasalistePage,
    KasaeklePage,
    CariborcdekontPage,
    CarialacakdekontPage,
    CariHareketleriPage,
    HareketdetayPage,
    GelirgidereklePage,
    BankaEkleGuncellePage,
    BankaHareketPage,
    BankListePage,
    BankaHavaleEftPage,
    KayitFormPage,
    AciklamaeklePage,
    AciklamaListePage,
    BirimeklePage,
    BirimListePage,
    KategoriEklePage,
    KategoriListePage,
    MarkaEklePage,
    MarkaListesiPage,
    ServisHareketPage,
    HareketDetayPage,
    ServishareketduzenlePage,
    RaporAnaSayfaPage,
    ServisKayitArsivPage,
    ServisOdemeYapPage,
    ServisDuzenlePage,
    SmsGonderPage,
    TeslimEdilenListesiPage,
    PersonelListesiPage,
    PersonelEkleGuncellePage,
    BekleyenListesiPage,
    ServisDetayPage,
    GrupEkleGuncellePage,
    GrupListesiPage,
    CarismsgonderPage,
    KasiyerBazliRaporPage,
    HakkindaPage,
    KasaHareketleriRaporPage,
    ServerConfigPage,
    AksesuareklemodalPage,
    MarkaeklemodalPage,
    ProgramKarsilamaPage,
    GeriBildirimPage,
    GeriBildirimEkleGuncellePage,
    AlacakliCariHesaplarReportPage,
    BorcluCariHesaplarReportPage,
    PersonelServisRaporuPage,
MarkaSecPage,
ProgramAyarlariPage,

  ],
  providers: [

    StatusBar,
    SplashScreen,
    BllOrtak,
    Servis,
    Ortak,
    // CallNumber,
    // SMS,
    Flashlight,

    { provide: ErrorHandler, useClass: IonicErrorHandler }, Ortak, Servis,Printer, AndroidFullScreen, BllOrtak, Camera, BarcodeScannerProvider, DalProvider,
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts